import moment from "moment";
import StatusCustom from "../../../../components/status/statusCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import { dateTimeToView } from "../../../../utils/date.utils";
import OptionsButtonCustom from "../../../../components/option-button/OptionsButtonCustom";
import { OnlineCourseApi, onlineCourseType, onlineCourseTypeList } from "../../../../api/online-corse/online_course.api";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../../store/loading/loading.slice";
import { alertActive, alertError, alertSuccess } from "../../../../components/alert/swal";


export const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const dispatch = useDispatch();
    const matches = useMediaQuery(theme.breakpoints.up("md"));

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [data, setData] = useState<any[]>([]);
    const [showModal, setShowModal] = useState<string>("");
    const [keyword, setKeyword] = useState<string>("");
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);


    const [formState, setFormState] = useState<{ online_course_type: string }>({
        online_course_type: ""
    })
    const [id_online_course_type, set_id_online_course_type] = useState<number | null>(null);


    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }
    const handleCloseModal = () => {
        setShowModal("");
        setFormState({ online_course_type: "" });
        set_id_online_course_type(null);
    }

    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const headCells = [
        {
            id: "id_online_course_type", width: 100, sortable: true, disablePadding: false, align: 'center', label: t("COMPLAINTS_ORDER")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "center", label: "ชื่อประเภทคอร์สเรียน"
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: "ผู้ที่สร้าง/ปรับปรุงล่าสุด"
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: "วันที่สร้าง/ปรับปรุงล่าสุด"
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 100, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            online_course_type,
            created_date,
            modified_date,
            modifier_name,
            id_online_course_type
        } =
            objData;

        // subject_no: "BUD32",
        // subject_name: "ปรัชญาพุทธศาสตร์",
        // status: "ACTIVE",
        // create_date: new Date(),
        // create_by: "นางมาริสา มากดีดก"
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: online_course_type || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modifier_name  || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: dateTimeToView(modified_date || created_date) || "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onViewClick={() => {
                                handleGetDetail(id_online_course_type);
                                setShowModal("VIEW");
                            }}
                            onEditClick={() => {
                                handleGetDetail(id_online_course_type);
                                setShowModal("EDIT");
                            }}
                            onDeleteClick={() => handleDeleteList(id_online_course_type)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };
    const handleSubmit = async () => {
        const body: onlineCourseType = {
            online_course_type: formState.online_course_type
        }
        dispatch(setLoading());
        if (id_online_course_type) {
            await OnlineCourseApi.updateType(id_online_course_type, body).then((res) => {
                if (res.status < 300) {
                    alertSuccess("อัพเดตแท็ก", "อัพเดตแท็ก เรียบร้อยแล้ว");
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                alertError("อัพเดตแท็ก", "อัพเดตแท็ก ไม่สำเร็จ")
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await OnlineCourseApi.createType(body).then((res) => {
                if (res.status < 300) {
                    alertSuccess("เพิ่มแท็ก", "เพิ่มแท็ก เรียบร้อยแล้ว");
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                alertError("เพิ่มแท็ก", "เพิ่มแท็ก ไม่สำเร็จ")
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    const handleGetDetail = async (id_online_course_type: number) => {
        dispatch(setLoading());
        set_id_online_course_type(id_online_course_type);
        await OnlineCourseApi.findOneType(id_online_course_type).then((res) => {
            if (res.status < 300) {
                const data = res.data;
                setFormState((prev) => ({ ...prev, online_course_type: data?.online_course_type }))
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleDeleteList = (id_online_course_type: number) => {
        alertActive("ลบรายการ", "ท่านต้องการลบรายการนี้?", undefined, undefined, async () => {
            dispatch(setLoading());
            await OnlineCourseApi.deleteType(id_online_course_type).then((res) => {
                if (res.status < 300) {
                    alertSuccess("ลบรายการ", "ลบรายการ เรียบร้อยแล้ว");
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError("ลบรายการ", "ลบรายการ เรียบร้อยแล้ว")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const handleGetData = useCallback(async () => {
        let query: onlineCourseTypeList = {
            page: page,
            limit: pageLimit,
        }
        dispatch(setLoading());
        if (keyword) query = { ...query, keyword: keyword }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        await OnlineCourseApi.typeList(query).then((res) => {
            if (res.status < 300) {
                const data_item = res.data?.data?.items || [];
                const total_item = res.data?.data?.meta?.totalItems || [];
                setData(data_item);
                setTotalItems(total_item)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, sortBy, sortType, endDate, startDate, keyword])


    useEffect(() => {
        handleGetData()
    }, [handleGetData])


    return {
        page,
        pageLimit,
        data,
        sortBy,
        sortType,
        handleRequestSort,
        setPage,
        setPageLimit,
        headCells,
        totalItems,
        renderData,
        handleCloseModal,
        formState,
        showModal,
        setShowModal,
        handleSubmit,
        setFormState,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange

    }
}